import ar from './ar.json';
import en from './en.json';

/**
 * The Verification module's catalogue, registered from `app.config.tsx` under the
 * `verification` namespace — `shared/i18n` never imports a module (W2).
 */
export const verificationCatalogs = { ar, en };
